import { createSelector } from 'reselect';

import { DEALERS_INSIGHTS_LEVELS } from '../level/constants';
import { selectCurrentLevel, selectCurrentDealerId } from '../level/selectors';

export const getDateRangeReducer = ({ dealersInsights }) =>
  dealersInsights.dateRange;

export const selectFirstDate = createSelector(
  [getDateRangeReducer],
  ({ firstDate }) => firstDate,
);

export const selectLastDate = createSelector(
  [getDateRangeReducer],
  ({ lastDate }) => lastDate,
);

export const selectDateRangeError = createSelector(
  [getDateRangeReducer],
  ({ error }) => error,
);

/**
 * @param {import('../../../../../shared/modules/dealersInsights/redux/level/reducer.defaultState').DealerInsightsLevel} selectedLevel
 * @param {string} [selectedDealerId]
 */
export const getDateRangeCacheDictionaryKey = (
  selectedLevel,
  selectedDealerId,
) => {
  if (selectedLevel === DEALERS_INSIGHTS_LEVELS.DEALER) {
    return `dealerId--${selectedDealerId}`;
  }
  return DEALERS_INSIGHTS_LEVELS.NETWORK;
};

export const selectDateRangeByFilteredLevel = createSelector(
  [getDateRangeReducer, selectCurrentLevel, selectCurrentDealerId],
  (dateRangeState, currentLevel, currentDealerId) => {
    return dateRangeState[
      getDateRangeCacheDictionaryKey(currentLevel, currentDealerId)
    ];
  },
);
export const selectFirstDateInDateRangeByFilteredLevel = createSelector(
  [selectDateRangeByFilteredLevel],
  state => {
    return state?.firstDate;
  },
);
